import React from 'react';
import { Button } from 'carbon-components-react';
import './Welcome.scss';
import { Popup24 } from '@carbon/icons-react';
import Cta from '../../Molecules/Cta/Cta';
import PublicImage from 'src/common/components/PublicImage';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type WelcomeProps = {
  handleLaunchModal: () => void;
  model2: boolean;
  setModel2: React.Dispatch<React.SetStateAction<boolean>>;
  modalBtnLangText: string;
  toggleCountry: boolean;
  localExist: boolean;
  flag: boolean;
  useTranslation: TranslationFunction;
};

const Welcome = ({
  handleLaunchModal,
  setModel2,
  modalBtnLangText,
  toggleCountry,
  localExist,
  flag,
  useTranslation,
}: WelcomeProps) => {
  return (
    <section className="welcome">
      <div className="bx--row">
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-3 ml-02">
          <div className="bx--row mt-mb-02">
            <div className="main-title">{useTranslation('secondary')}</div>
          </div>
          <div className="bx--row mt-mb-02">
            <div className="main-title-link"></div>
          </div>
          <div className="bx--row mt-01">
            <div className="main-title">{useTranslation('launch_text')}</div>
          </div>
          <div className="bx--row mt-mb-02">
            <Button onClick={handleLaunchModal} renderIcon={Popup24}>
              {useTranslation('start_btn_text')}
            </Button>
            {flag && localExist && toggleCountry && (
              <Cta
                value={`${convertToString(
                  useTranslation('accessPageCapitalized', true),
                )} ${modalBtnLangText}`}
                handleClick={() => setModel2(true)}
                kind="tertiary"
                iconType="arrow"
                classes="ml2"
              />
            )}
          </div>
        </div>
        <div className="bx--col-lg-4 bx--col-md-3 bx--col-sm-3 animation">
          <PublicImage
            imgPath={'images/animation-crop.gif'}
            widgetId="maas360-estimator"
            alt="animation-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Welcome;
